// @flow

import React, { Component } from 'react';
import Relay from 'react-relay';
import styler from 'react-styling';
import { StyleRoot } from 'radium';

import { MeetingRoomHeader, MeetingRoomFooter } from '../index';
import ContactAvatar from '../ContactAvatar';
import breakpoints from '../../../css/breakpoints';
import { filterNotNullEdgeNodes } from '../../libs/Extract';

function _createStyle(theme: string) {
  return styler `
    Container
      background-color: ${theme === 'dark' ? '#212121' : '#f7f7f9'}
      width: 100%
      height: 100%
      font-size: 22px
      color: ${theme === 'dark' ? '#D0D3D5' : '#333'}
      top: 0
      left: 0
      z-index: 10000
      position: fixed
      @media screen and (max-width: ${breakpoints.SMALL_AND_BELOW}px)
        font-size: 14px
      @media screen and (min-width: ${breakpoints.MEDIUM_AND_BELOW}px)
        font-size: 16px
      @media screen and (min-width: ${breakpoints.LARGE_AND_BELOW}px)
        font-size: 20px
    Title
      text-align: center
    LocationsContainer
      display: flex
      justify-content: space-around
      width: 100%
      flex-wrap: wrap
      margin-top: 10%
    Location
      @media screen and (min-width: ${breakpoints.MEDIUM_AND_BELOW}px)
        flex: 0 1 calc(20% - 8px)
      @media screen and (min-width: ${breakpoints.LARGE_AND_BELOW}px)
        flex: 0 1 calc(20% - 8px)
        margin: 40px
    Link
      text-decoration: none 
      color: ${theme === 'dark' ? '#C7CBCE' : '#2a363c'}
  `;
}

class MeetingRoomList extends Component {
  props: {
    location: Object,
    viewer: Object,
  }

  _onToggle = (theme) => {
    this.props.location.query.theme = theme;
    this.forceUpdate();
  }

  render() {
    const rooms = filterNotNullEdgeNodes(this.props.viewer.meetingRooms);
    const theme = this.props.location.query.theme === 'light' ? 'light' : 'dark';
    const style = _createStyle(theme);
    const roomsDivs = rooms.map((room) =>
      <a key={room.id} href={`#/meetingroom/${room.id}`} style={style.Link}>
        <div>
          <div style={style.Location}>
            <ContactAvatar
              displayName={room.displayName}
              imagePath={room.email ? `/contacts/photo/${room.email}` : null}
              width="150px"
              height="150px"
              margin="0px"
              border-radius="0px!important"
              textAlign="center"
              fontSize="30px"
            />
          </div>
          <h3 style={style.Title}>{room.displayName}</h3>
        </div>
      </a>
    );
    return (
      <StyleRoot>
        <div style={style.Container}>
          <MeetingRoomHeader text="Pick Room" theme={theme} />
          <div style={style.LocationsContainer}>
            {roomsDivs}
          </div>
          <MeetingRoomFooter theme={theme} onToggle={this._onToggle} />
        </div>
      </StyleRoot>
    );
  }

}

export default Relay.createContainer(MeetingRoomList, {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        meetingRooms(first: 10000) {
          edges {
            node {
              id
              email
              displayName
            }
          }
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ./src/js/Components/MeetingRooms/MeetingRoomList.js